export default "__VITE_ASSET__v9II9FYf__"